import { Button, CircularProgress, Grid2, Paper, TextField } from "@mui/material";
import Wrapper from "../components/Wrapper"
import { useEffect, useState } from "react";
import { addBlog, getBlog, updateBlog } from "../services/blogs";
import { enqueueSnackbar } from "notistack";
import { useParams } from "react-router-dom";
import PageLoader from "../components/PageLoader";
import Editor from "../components/Editor";

const BlogForm = () => {

  const [title, set_title] = useState('');
  const [summary, set_summary] = useState('');
  const [blog_details, set_blog_details] = useState('');
  const [is_saving, set_is_saving] = useState(false);
  const [is_loading, set_is_loading] = useState(false);

  const params = useParams();

  const blog_id = params.id;

  const handleSave = async () => {
    set_is_saving(true);

    let data_obj = null;

    const detail_obj = {
      title : title,
      summary : summary,
      details : blog_details
    }

    if(blog_id){
      const {data} = await updateBlog({
        data : detail_obj,
        id : blog_id
      })
      
      data_obj = data;
    }else{
      const {data} = await addBlog(detail_obj)

      set_title('');
      set_summary('');
      set_blog_details('');

      data_obj = data;
    }
    
    set_is_saving(false)

    if(data_obj && data_obj.success){
      enqueueSnackbar('Blog saved successfully !', {
        variant : 'success'
      });
    }else{
      enqueueSnackbar('Error while saving blog !', {
        variant : 'error'
      });
    }
  }

  useEffect(() => {
    if(blog_id){
      getData();
    }
    // eslint-disable-next-line
  }, [blog_id])

  const getData = async () => {
    set_is_loading(true);
    const {data} = await getBlog({
      id : blog_id
    });

    set_is_loading(false);

    if(data && data.success){
      set_title(data.data.title);
      set_summary(data.data.summary);
      set_blog_details(data.data.details);
    }
  }

  return(
    <Wrapper>
      <PageLoader
        show={is_loading}
      />
      <Paper
        sx={{
          padding : '20px'
        }}
      >
        <Grid2
          container
          spacing={3}
        >
          <Grid2 size = {3}>
            <TextField
              fullWidth
              label="Title"
              value={title}
              onChange={(e) => set_title(e.target.value)}
            />
          </Grid2>

          <Grid2 size = {9}>
            <TextField
              multiline
              fullWidth
              label="Summary"
              value={summary}
              onChange={(e) => set_summary(e.target.value)}
              rows={3}
            />
          </Grid2>

          <Grid2 size = {12}>

            <Editor
              value={blog_details}
              onChange={set_blog_details}
            />
          </Grid2>

          <Grid2
            size = {12}
            display='flex'
            justifyContent='flex-end'
          >
            <Button
              variant="contained"
              disabled = {
                is_saving ||
                !Boolean(title) ||
                !Boolean(summary) ||
                !Boolean(blog_details)
              }
              onClick={handleSave}
            >
              {
                is_saving ?
                <CircularProgress
                  color="inherit"
                  size='20px'
                />
                : "Save"
              }
            </Button>
          </Grid2>
        </Grid2>
      </Paper>
    </Wrapper>
  )
}

export default BlogForm;